import React, {
  useState
  // useEffect
} from "react";
import { createBrowserHistory } from "history";
import { Switch, Router, Route, Redirect } from "react-router-dom";
// Externals
import { Chart } from "react-chartjs-2";
// Material helpers
import { ThemeProvider } from "@material-ui/styles";
// ChartJS helpers
import { chartjs } from "./helpers";
// Theme
import theme from "./theme";
import { CircularProgress } from "@material-ui/core";
// Styles
import "react-perfect-scrollbar/dist/css/styles.css";
import "./assets/scss/index.scss";
// Routes
import Routes from "./Routes";
import { Dashboard as DashboardLayout } from "./layouts";
import { useQuery } from "@apollo/react-hooks";
import { cacheQueries } from "./apollo/queries/cache";

const {
  IS_LOGIN,
  GET_LANGUAGE,
  GET_DIRECTION
  // , GET_TOKEN
} = cacheQueries;

// Browser history
const browserHistory = createBrowserHistory();

// Configure ChartJS
Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

const App = props => {
  const [
    loading
    // setLoading
  ] = useState(props.token ? true : false);
  // const {
  //   data:
  //   { token }
  // } = useQuery(GET_TOKEN);
  const {
    data: { isLogin }
  } = useQuery(IS_LOGIN);
  const {
    data: { language }
  } = useQuery(GET_LANGUAGE);
  const {
    data: { direction }
  } = useQuery(GET_DIRECTION);
  // console.log(token, "app js");
  // useEffect(() => {
  //   if (isLogin) {
  //     console.log("test");
  //     client
  //       .query({ query: USER_LOGIN })
  //       .then(() => setLoading(false))
  //       .catch(() => {
  //         setLoading(false);
  //         client.writeQuery({
  //           query: GET_TOKEN,
  //           data: { token: null }
  //         });
  //         client.writeQuery({
  //           query: IS_LOGIN,
  //           data: { isLogin: false }
  //         });
  //       });
  //   }
  // eslint-disable-next-line
  // }, []);

  console.log(isLogin);

  return loading ? (
    <div style={{ textAlign: "center", lineHeight: "100vh" }}>
      <CircularProgress />
    </div>
  ) : (
    <ThemeProvider theme={theme}>
      <Router history={browserHistory}>
        <Switch>
          {isLogin ? (
            <DashboardLayout language={language} direction={direction}>
              {Routes[1].map((router, i) => (
                <Route
                  key={i}
                  path={router.link}
                  render={() => (
                    <router.component
                      language={language}
                      direction={direction}
                    />
                  )}
                  exact
                />
              ))}
            </DashboardLayout>
          ) : (
            Routes[0].map((router, i) => (
              <Route
                key={i}
                path={router.link}
                render={() => (
                  <router.component language={language} direction={direction} />
                )}
                exact
              />
            ))
          )}

          {/* {isLogin ? (
            <Redirect from="*" to="/products" />
          ) : (
            <Redirect to="/sign-in" />
          )} */}
          {!isLogin && <Redirect to="/sign-in" />}
        </Switch>
      </Router>
    </ThemeProvider>
  );
};

export default App;
